import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { CreateRoleRequest, Role } from '../../../../typings/api';

import { rolesQueryKey } from './useRoles';

async function createRole(role: CreateRoleRequest): Promise<Role> {
  const response = await post<CreateRoleRequest, Role>('/api/roles', role);
  return response.data as Role;
}

/**
 * Create a new custom role.
 */
export default function useCreateRole() {
  return useToastedMutation({
    mutationFn: createRole,
    successToastMessage: (data: Role) => `Role "${data.name}" created successfully`,
    errorToastMessage: 'Failed to create role',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: rolesQueryKey });
    },
  });
}
